import { CompensationMethodType } from "@redotech/congo-enums/compensation-method-type";
import { ReturnOptionMethod } from "../return-flow/return-option";

export const compensationMethodTypeMap: {
  [key in CompensationMethodType]: ReturnOptionMethod["type"];
} = {
  [CompensationMethodType.Exchange]: ReturnOptionMethod.EXCHANGE,
  [CompensationMethodType.Storecredit]: ReturnOptionMethod.STORE_CREDIT,
  [CompensationMethodType.Refund]: ReturnOptionMethod.REFUND,
  [CompensationMethodType.Repair]: ReturnOptionMethod.REPAIR,
};
